import React, { Component } from 'react';

import RadioButton from '../../../../../components/ZUILib/RadioButton';
import WapButtomPopUp from '../../../../../components/WapButtomPopUp/WapButtomPopUp';
import CategoryFilterSvg from '../../../../../components/SvgsComponents/CategoryFilterSvg';

class CategoriesFilter extends Component {
  constructor(props) {
    super(props);
    this.categoryList = this.props.categoryList;
    this.state = {
      show: false,
    };
  }

  handleShowModal = () => {
    const body = document.getElementsByTagName('body')[0];
    body.classList.add('noscroll');
    this.setState({ show: true });
  };

  handleCloseModal = () => {
    document.body.classList.remove('noscroll');
    this.setState({ show: false });
  };

  render() {
    const categoriesSelection = () => (
      <section className="filtersTable">
        <h5 style={{ margin: 0, marginBottom: 26, color: '#333333' }}>Categoría</h5>
        <div
          style={{ display: 'flex', flexDirection: 'column', textTransform: 'lowercase' }}
        >
          {this.categoryList.options.map((option, index) => (
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 17, height: 40, color: '#333' }}>
              <div key={index}>
                <RadioButton
                  id={option.id}
                  value={option.value}
                  name={this.categoryList.name}
                  radioCssClass={'radio'}
                  onChangeFunction={(e) => {
                    this.props.filterCategories(e);
                    this.handleCloseModal();
                  }}
                  onClickFunction={this.handleCloseModal}
                />
              </div>
              <div>{option.displayName}</div>
            </div>
          ))}
        </div>
      </section>
    );

    return (
      <div
        style={{
          height: 41,
          width: '50%',
          display: 'flex',
          fontWeight: 700,
          color: '#767676',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          onClick={() => { this.handleShowModal(); }}
          style={{
            gap: 10,
            fontSize: 14,
            display: 'flex',
            color: '#999999',
            verticalAlign: 'top',
            alignItems: 'center',
          }}
        >
          <span>Filtrar por categorías</span>
          <CategoryFilterSvg />
        </div>
        { this.state.show &&
          <WapButtomPopUp
            handleCloseModal={this.handleCloseModal}
            modalTitle="Filtrar por:"
            maxHeight={500}
          >
            {categoriesSelection()}
          </WapButtomPopUp>
        }
      </div>
    );
  }
}

export default CategoriesFilter;
